import GiftTextProvider from './hooks/useGiftText';

import { GiftTextProps } from './@types/GiftTextProps';

const GiftText = (props: GiftTextProps) => (
	<GiftTextProvider {...props}>
		<span className="vtex-product-gifts-0-x-productGiftText productGiftText">
			{!props.text ? '2 brinde(s)' : props.text?.replace('{totalGifts}', '2')}
		</span>
	</GiftTextProvider>
);

export default GiftText;
